import { render, staticRenderFns } from "./ModalDonate.vue?vue&type=template&id=0282541c"
import script from "./ModalDonate.vue?vue&type=script&lang=js"
export * from "./ModalDonate.vue?vue&type=script&lang=js"
import style0 from "./ModalDonate.vue?vue&type=style&index=0&id=0282541c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports